<template>
  <v-layout class="wrapper" justify-space-between>
    <v-layout align-center>
      <v-btn
        icon
        style="margin: 0"
        @click="$emit('clear')"
      >
        <v-icon color="white">
          clear
        </v-icon>
      </v-btn>
      <div class="pointer" />
      <div v-if="selected.length === 1"><span class="text">{{ selected.length }} {{ name }} selected</span></div>
      <div v-else><span class="text">{{ selected.length }} {{ name }}s selected</span></div>
    </v-layout>
    <v-layout justify-end align-center>
      <main-button
        depressed
        text="delete"
        class="desktop-button"
        @click="$emit('delete')"
      />
      <v-btn icon class="hide" @click="$emit('delete')">
        <v-icon color="white">delete</v-icon>
      </v-btn>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: 'selected-items-header',
  props: {
    selected: Array,
    name: String,
  },
}
</script>

<style scoped>
  .wrapper {
    color: white;
    margin: 0 0 2px 0;
    padding: 14px 10px;
    background-color: #0277bd;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 56px;
    position: relative;
  }
  .text {
    font-family: Raleway;
    font-size: 16px;
    font-weight: bold;
  }
  .pointer {
    position: relative;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #0277bd;
    top: 30px;
    right: 30px;
  }
</style>
